/**
 * Converts a cents value (integer) to dollars (decimal).
 * Handles string input since some API fields return monetary values as strings.
 */
export function centsToDollars(cents: number | string | null | undefined): number | null {
  if (cents === null || cents === undefined) return null

  const parsed = typeof cents === 'string' ? Number(cents) : cents

  if (Number.isNaN(parsed)) return null

  return parsed / 100
}

/**
 * Converts a dollars value (decimal) to cents (integer).
 * Uses Math.round to avoid floating-point precision issues.
 */
export function dollarsToCents(dollars: number | null): number | null {
  if (dollars === null) return null

  return Math.round(dollars * 100)
}

/**
 * Formats a value as USD currency string (e.g. "$1,234.56").
 * Accepts number, string, null, or undefined.
 */
export function formatCurrency(value: number): string
export function formatCurrency(value: string | null | undefined): string | null
export function formatCurrency(value: number | string | null | undefined): string | null {
  if (value === null || value === undefined) return null
  if (typeof value === 'number') {
    if (Number.isNaN(value)) return null
    return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' })
  }
  // Handle multi-value strings like "$13,987.00, $13,987.00" — take the first value
  const firstValue = value.split(/,\s+/)[0].trim()
  const cleaned = firstValue.replace(/[^0-9.-]/g, '')
  if (!cleaned) return null
  const parsed = Number(cleaned)
  if (Number.isNaN(parsed)) return null
  return parsed.toLocaleString('en-US', { style: 'currency', currency: 'USD' })
}
